var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUbahProfil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66178 0.226757C1.39433 -0.0775037 0.96263 -0.0752929 0.697554 0.231695C0.432478 0.538683 0.434404 1.0342 0.701856 1.33846L2.30455 3.16174C2.955 3.90171 3.40119 4.41097 3.7031 4.84247C3.99637 5.26164 4.09698 5.53087 4.12375 5.772C4.14057 5.9234 4.14057 6.0766 4.12375 6.228C4.09698 6.46913 3.99637 6.73836 3.7031 7.15752C3.40119 7.58903 2.955 8.09829 2.30456 8.83826L0.701856 10.6615C0.434404 10.9658 0.432478 11.4613 0.697554 11.7683C0.96263 12.0753 1.39433 12.0775 1.66178 11.7732L3.29336 9.91712C3.90787 9.21805 4.41013 8.64669 4.76631 8.13761C5.1367 7.60822 5.40482 7.0709 5.47645 6.42591C5.50785 6.1431 5.50785 5.8569 5.47645 5.57409C5.40482 4.9291 5.1367 4.39177 4.76631 3.86239C4.41012 3.35331 3.90788 2.78196 3.29335 2.08288L1.66178 0.226757Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbahProfil);
export default __webpack_public_path__ + "static/media/ubahProfil.40b20c3fd2d2f3e76938481094051b78.svg";
export { ForwardRef as ReactComponent };